document.addEventListener('DOMContentLoaded', () => {
	(
		document.querySelectorAll('.notification .notification__close') || []
	).forEach(($notificationClose) => {
		const notification = document.querySelector('.notification');
		const notificationHeight = document.querySelector('.notification');
		const notificationPageContent = document.querySelector('#page-content');

		// prevent page content cut off on pages with a notification
		notificationPageContent.style.marginTop =
			notificationHeight.scrollHeight + 'px';

		window.addEventListener('resize', function () {
			notificationPageContent.style.marginTop =
				notificationHeight.scrollHeight + 'px';
		});

		$notificationClose.addEventListener('click', () => {
			notification.parentNode.removeChild(notification);

			notificationPageContent.style.marginTop = '0px'; // reset the top margin back to 0 on close
		});
	});
});
